export default "__VITE_ASSET__DuHHVAeC__"